module.exports = __webpack_public_path__ + "static/media/COS_LAZARTIGUE.e3768590.webp";